import { Logger as ConsoleLogger } from './impl/console';
import { Logger as PinoLogger } from './impl/pino';
import { Logger as LoggerInstance } from './logger';

// Define the type for the logger provider.  Currently supporting 'pino'.
type LoggerProvider = 'pino' | 'console';

// Use pino as the default logger provider
const LOGGER = (process.env.LOGGER ?? 'pino') as LoggerProvider;

// Map of logger implementations
const loggerImplementations: Record<LoggerProvider, LoggerInstance> = {
  pino: PinoLogger,
  console: ConsoleLogger,
};

/**
 * @name getLogger
 * @description Retrieves the logger implementation based on the LOGGER environment variable.
 */
export function getLogger(): LoggerInstance {
  return loggerImplementations[LOGGER];
}

export const logger = getLogger();

export default logger;
